import React from "react";
import "./resultBodyByType.css";
import Ab20ResultBody from "./Ab20ResultBody";
import Ab3ResultBody from "./Ab3ResultBody";
import AbjResultBody from "./AbjResultBody";
import BaccaratResultBody from "./BaccaratResultBody";
import BtableResultBody from "./BtableResultBody";
import Card32ResultBody from "./Card32ResultBody";
import Cmatch20ResultBody from "./Cmatch20ResultBody";
import Cmeter1ResultBody from "./Cmeter1ResultBody";
import CmeterResultBody from "./CmeterResultBody";
import DoliDanaResultBody from "./DoliDanaResultBody";
import DragonTigerResultBody from "./DragonTigerResultBody";
import Dt6ResultBody from "./Dt6ResultBody";
import DtlResultBody from "./DtlResultBody";
import Dum10ResultBody from "./Dum10ResultBody";
import FiveCricketResultBody from "./FiveCricketResultBody";
import GoalResultBody from "./GoalResultBody";
import Joker1ResultBody from "./Joker1ResultBody";
import Joker20ResultBody from "./Joker20ResultBody";
import KbcResultBody from "./KbcResultBody";
import LottResultBody from "./LottResultBody";
import Lucky15ResultBody from "./Lucky15ResultBody";
import Lucky7ResultBody from "./Lucky7ResultBody";
import MogamboResultBody from "./MogamboResultBody";
import NoteNumResultBody from "./NoteNumResultBody";
import Patti2ResultBody from "./Patti2ResultBody";
import Poison20ResultBody from "./Poison20ResultBody";
import PoisonResultBody from "./PoisonResultBody";
import Poker20ResultBody from "./Poker20ResultBody";
import Poker6ResultBody from "./Poker6ResultBody";
import PokerResultBody from "./PokerResultBody";
import QueenResultBody from "./QueenResultBody";
import Race17ResultBody from "./Race17ResultBody";
import Race20ResultBody from "./Race20ResultBody";
import Race2ResultBody from "./Race2ResultBody";
import RouletteResultBody from "./RouletteResultBody";
import SicboResultBody from "./SicboResultBody";
import SuperOver3ResultBody from "./SuperOver3ResultBody";
import Teen120ResultBody from "./Teen120ResultBody";
import Teen1DayResultBody from "./Teen1DayResultBody";
import Teen1ResultBody from "./Teen1ResultBody";
import Teen20ResultBody from "./Teen20ResultBody";
import Teen6ResultBody from "./Teen6ResultBody";
import Teen8ResultBody from "./Teen8ResultBody";
import Teen9ResultBody from "./Teen9ResultBody";
import TeenInstantResultBody from "./TeenInstantResultBody";
import TeenMufResultBody from "./TeenMufResultBody";
import TeenTopOpenResultBody from "./TeenTopOpenResultBody";
import TeenUniqueResultBody from "./TeenUniqueResultBody";
import TeensinResultBody from "./TeensinResultBody";
import ThreeCardJResultBody from "./ThreeCardJResultBody";
import TrapResultBody from "./TrapResultBody";
import TrioResultBody from "./TrioResultBody";
import WarResultBody from "./WarResultBody";
import WorliResultBody from "./WorliResultBody";

/**
 * Casino result report (reports/casinoresult/:type) → the same reference result-modal body the
 * game page's Last Result modal renders for that game (the reference uses one Vue component for both).
 * Each entry: { Body, props(type) } — props mirror exactly what the game page passes besides t1.
 */
const entry = (Body, props) => ({ Body, props: props || (() => ({})) });
const withGameType = (type) => ({ gameType: type });

const GROUPS = [
  [entry(Teen1DayResultBody), ["teen", "pteen", "tteen", "vteen", "teen62"]],
  [entry(Teen20ResultBody, withGameType), ["teen20", "teen20b", "teen20c", "pteen20", "tteen20", "vteen20", "teen20v"]],
  [entry(Teen8ResultBody), ["teen8"]],
  [entry(Teen9ResultBody), ["teen9"]],
  [entry(Teen6ResultBody), ["teen6"]],
  [entry(Teen1ResultBody), ["teen1"]],
  [entry(Teen120ResultBody), ["teen120"]],
  [entry(TeensinResultBody), ["teensin"]],
  [entry(TeenMufResultBody), ["teenmuf", "vteenmuf"]],
  [entry(Patti2ResultBody), ["patti2"]],
  [entry(TeenTopOpenResultBody), ["teen41", "teen42"]],
  [entry(TeenInstantResultBody), ["teen3", "teen32", "teen33"]],
  [entry(TeenUniqueResultBody), ["teenunique"]],
  [entry(Joker1ResultBody), ["joker1", "joker120"]],
  [entry(Joker20ResultBody), ["teenjoker", "joker20"]],
  [entry(PoisonResultBody), ["poison"]],
  [entry(Poison20ResultBody), ["poison20"]],
  [entry(PokerResultBody), ["poker"]],
  [entry(Poker6ResultBody), ["poker6"]],
  [entry(Poker20ResultBody), ["poker20"]],
  [entry(ThreeCardJResultBody), ["3cardj"]],
  [entry(Lucky7ResultBody, () => ({ variant: "aaa" })), ["aaa", "aaa2", "vaaa"]],
  [entry(Lucky7ResultBody, () => ({ variant: "lucky7" })), ["lucky7", "lucky7eu", "lucky7eu2", "plucky7", "tlucky7", "vlucky7", "lucky5"]],
  [entry(Lucky15ResultBody), ["lucky15", "ballbyball"]],
  [entry(Ab20ResultBody), ["ab20"]],
  [entry(AbjResultBody), ["abj"]],
  [entry(Ab3ResultBody), ["ab3", "ab4"]],
  [entry(BaccaratResultBody, withGameType), ["baccarat", "baccarat2", "pbaccarat", "tbaccarat", "vbaccarat"]],
  [entry(BtableResultBody), ["btable", "btable2", "vbtable"]],
  [entry(Card32ResultBody, () => ({ gameType: "card32" })), ["card32", "pcard32", "tcard32"]],
  [entry(Card32ResultBody, () => ({ gameType: "card32eu" })), ["card32eu"]],
  [entry(Cmatch20ResultBody), ["cmatch20"]],
  [entry(CmeterResultBody), ["cmeter"]],
  [entry(Cmeter1ResultBody), ["cmeter1"]],
  [entry(FiveCricketResultBody), ["superover", "superover2", "cricketv3"]],
  [entry(SuperOver3ResultBody), ["superover3"]],
  [entry(DragonTigerResultBody), ["dt20", "dt202", "pdt20", "tdt20", "vdt20"]],
  [entry(Dt6ResultBody), ["dt6", "pdt6", "tdt6", "vdt6"]],
  [entry(DtlResultBody), ["dtl20", "vdtl20"]],
  [entry(LottResultBody), ["lottcard"]],
  [entry(WarResultBody), ["war"]],
  [entry(WorliResultBody), ["worli", "worli2", "worli3"]],
  [entry(QueenResultBody), ["queen"]],
  [entry(Race20ResultBody), ["race20"]],
  [entry(Race17ResultBody), ["race17", "vrace17"]],
  [entry(Race2ResultBody), ["race2"]],
  [entry(TrapResultBody), ["trap", "vtrap"]],
  [entry(TrioResultBody), ["trio", "vtrio"]],
  [entry(NoteNumResultBody), ["notenum"]],
  [entry(KbcResultBody), ["kbc"]],
  [entry(MogamboResultBody), ["mogambo"]],
  [entry(DoliDanaResultBody), ["dolidana"]],
  [entry(GoalResultBody), ["goal", "goal2"]],
  [entry(SicboResultBody), ["sicbo", "sicbo2"]],
  [entry(Dum10ResultBody), ["dum10"]],
  [entry(RouletteResultBody), ["ourroullete", "roulette11", "roulette12", "roulette13"]],
];

const RESULT_BODY_BY_TYPE = Object.fromEntries(
  GROUPS.flatMap(([e, types]) => types.map((type) => [type, e]))
);

/** Renders the reference body for `gameType` with the round detail `t1` (null if the type has none). */
export default function ResultBodyByType({ gameType, t1 }) {
  const type = String(gameType || "").toLowerCase();
  const e = RESULT_BODY_BY_TYPE[type];
  if (!e || !t1) return null;
  const { Body, props } = e;
  return <Body t1={t1} {...props(type)} />;
}

/** true when `gameType` has a reference body (else callers fall back to the old generic bodies). */
ResultBodyByType.has = (gameType) =>
  Object.prototype.hasOwnProperty.call(RESULT_BODY_BY_TYPE, String(gameType || "").toLowerCase());
